/**
 * Sense → Funnel. Slice 60.
 *
 * The fetch and the frame. What the screen draws, and why every stage is
 * measured or a sentence, is argued in `FunnelContent.tsx`.
 *
 * Slice 65 gave every Sense screen the same band at the top: the eyebrow
 * "Sense" with the pillar's glyph, and one line on what this screen answers.
 * Since the split into Reach, Connect and Sense, a person arriving here from a
 * link on the Overview or a campaign page needs to be told which part of Wend
 * they are in; the sidebar says it too, but only to someone who looks there.
 * The band sits here in the Page wrapper and not in the Content component
 * that `verify-sense-screens` renders, so those renders stay the screen's
 * substance and do not start counting a header's words. The name and glyph
 * come from `lib/pillars.tsx`, the one place a pillar is named.
 */
import { PageHeader } from '@wend/ui';

import { AppLayout } from '../../components/AppLayout';
import { ErrorState } from '../../components/ErrorState';
import { fetchFunnel } from '../../lib/api/sense';
import { PILLAR_IDENTITY } from '../../lib/pillars';
import { useAsyncData } from '../../lib/use-async-data';
import { FunnelContent } from './FunnelContent';

export function FunnelPage() {
  const { data, error, status, reload } = useAsyncData((signal) => fetchFunnel(signal), []);

  return (
    <AppLayout title="Funnel">
      <PageHeader
        eyebrow={PILLAR_IDENTITY.sense.label}
        icon={PILLAR_IDENTITY.sense.icon}
        lede="From your contacts to a conversion: who was reached, engaged, responded and converted."
      />
      <div className="flex flex-col gap-6" data-role="funnel-page">
        {status === 'error' && data === null && (
          <ErrorState
            error={error}
            title="Could not load the funnel"
            onRetry={reload}
            className="flex flex-col items-start gap-3 rounded-base border border-line px-4 py-5"
          />
        )}
        {data !== null && <FunnelContent funnel={data} />}
      </div>
    </AppLayout>
  );
}
